<template>
    <div class="row mt-5">
        <div class="offset-md-3 col-md-6">
            <div class="bg-white p-3 shadow-sm rounded-lg">
                <div>
                    <h4 class="font-weight-bold mb-3">Redirecting</h4>
                    <div class="mb-4">
                        <p class="text-muted">Please wait...</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Redirect",
    data() {
        return {
            code: '',
            channel: 'flock',
            code_sent: false
        }
    },
    mounted() {
        const token = new URLSearchParams(window.location.search).get('token');
        if (token) {
            localStorage.setItem('token', token);
            window.location.href = '/'
        }
    }
}
</script>

<style scoped>

</style>